import { IForumTag } from 'Frontend/scripts/models/forums.model'
import { FunctionComponent, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { deleteForumTag, updateForumTag } from 'Frontend/scripts/services/dashboard.service'
import { useTranslation } from 'react-i18next'
import Dialog from 'Features/Dialog/Dialog'

interface TagProps {
  tag: IForumTag
  isAdmin: boolean
  isModerator: boolean
  callback: () => void
}

interface ITagName {
  tagName: string
}

const ManageTag: FunctionComponent<TagProps> = ({ tag, isAdmin, callback }) => {
  const { t } = useTranslation()
  const [isEditing, setIsEditing] = useState<boolean>(false)
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const [editableTagName, setIsEditableTagName] = useState<string>(tag.name)

  const { register, handleSubmit, reset, watch } = useForm<ITagName>({
    defaultValues: {
      tagName: tag.name,
    },
  })

  const deleteTag = (tagId: string) => {
    deleteForumTag(tagId).then(() => {
      callback()
    })
  }

  const onSubmitEditTag = (data: ITagName) => {
    updateForumTag(tag.id, data.tagName).then(() => {
      setIsEditableTagName(data.tagName)
      setIsEditing(false)
    })
  }

  return (
    <div
      className="badge bg-secondary rounded-pill forum-thread__tags text-capitalize text-wrap py-1 d-flex align-items-center fw-normal"
      key={tag.id}
    >
      {!isEditing ? (
        <>
          {editableTagName !== null && editableTagName}
          {isAdmin && (
            <>
              <Button
                variant=""
                className="dashboard-tags__button ms-3"
                title={t('redigera')}
                onClick={() => setIsEditing(!isEditing)}
              >
                <i className="fa fa-pencil" />
              </Button>
              <Button
                variant=""
                className="dashboard-tags__button ms-2"
                title={t('delete')}
                onClick={() => setIsDialogOpen(true)}
              >
                <i className="fa fa-trash-o" />
              </Button>
              <Dialog
                callbackClose={() => setIsDialogOpen(false)}
                callbackSubmit={() => deleteTag(tag.id)}
                isOpen={isDialogOpen}
                buttonVariant="secondary"
                abortText={t('abort')}
                submitText={t('yes')}
                verificationText={`${t('tags.do-you-want-to-delete')} "${tag.name}"`}
              ></Dialog>
            </>
          )}
        </>
      ) : (
        <>
          <Form noValidate onSubmit={handleSubmit(onSubmitEditTag)} className="d-flex">
            <Form.Control
              className="dashboard-tags__edit-input"
              size="sm"
              type="text"
              htmlSize={watch('tagName') ? watch('tagName').length : 5}
              {...register('tagName', { required: t('error-add-heading') })}
            />
            <Button variant="" type="submit" className="dashboard-tags__button ms-2" title={t('approve')}>
              <i className="fa fa-check" />
            </Button>
            <Button
              variant=""
              className="dashboard-tags__button ms-2"
              title={t('abort')}
              onClick={() => {
                setIsEditing(false)
                reset({ tagName: editableTagName })
              }}
            >
              <i className="fa fa-times" />
            </Button>
          </Form>
        </>
      )}
    </div>
  )
}

export default ManageTag
